// Path the cabinet is served under on its host, e.g. '/claims/'. This is NOT where
// its files come from: on a CDN deploy Vite's `base` is the CDN URL. Unset means
// the legacy root deploy.
export const APP_ROUTER_BASE = import.meta.env.VITE_ROUTER_BASE || '/';

// For URLs that leave the router (payment and OAuth return URLs, window.open):
// the router adds the base to its own links but not to these. '/' adds nothing.
export const withRouterBase = path => `${APP_ROUTER_BASE.replace(/\/$/, '')}${path}`;
